module.exports = __webpack_public_path__ + "static/img/m_role.60dfc48.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/qa/m_role.png
// module id = fQQ2
// module chunks = 7